import { CSSProperties, memo, useEffect } from "react";
import { Button, Col, Divider, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlIdCodeNamePair } from "../../models/domain/IdCodeNamePair";
import { faCheck, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type StopFreeSaleReportOptionsSelectProps = {
    data?: mdlIdCodeNamePair[];
    onChange?: Function;
    fnSelectAll?: Function;
    fnClearAll?: Function;
    excludedValue?: string;
    id?: string;
    style?: CSSProperties;
    value?: string[];
    disabled?: boolean;
}


export const StopFreeSaleReportOptionsSelect = memo(function StopFreeSaleReportOptionsSelect(props: StopFreeSaleReportOptionsSelectProps) {
    const { t } = useTranslation();
    const checkBoxSpan = window.innerWidth < 1024 ? 12 : 8;

    useEffect(() => {
    }, [props]);


    return (
        <>
            <Select
                maxTagCount="responsive"
                disabled={props.disabled}
                size="middle"
                mode="multiple"
                value={props.value as string[]}
                style={props.style && props.style}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.choose")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={props.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}

                dropdownRender={(menu) => (
                    <>
                        <Row gutter={16} className="mb-1 mt-1">
                                <Col span={12}>
                                    <Button type="text" className="btn btn-sm btn-outline-primary w-100" onClick={() => props.fnSelectAll && props.fnSelectAll()}>
                                        <FontAwesomeIcon icon={faCheck} />
                                        {t('common.checkAll')}
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button type="text" className="btn  btn-sm btn-outline-secondary w-100" onClick={() => props.fnClearAll && props.fnClearAll()}>
                                    <FontAwesomeIcon icon={faTrash} />
                                        {t('common.clear')}
                                    </Button>
                                </Col>
                            </Row>
                        <Divider style={{ margin: '8px 0' }} />
                        {menu}
                    </>
                )}
            />
        </>
    )
})